import { useState, useEffect } from "react";

import styled from "styled-components";

import { useTranslation } from "react-i18next";
import { IconButton, Menu, MenuItem } from "@mui/material";

import i18nUtil from "../utils/i18n";
import { locales } from "../utils/constants";
import { localStorageHelpers } from "../utils/helpers";

const LanguageSelector = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { i18n } = useTranslation();

  const storedLang = localStorageHelpers.getFromLocalStorage("lang");
  useEffect(() => {
    if (storedLang) {
      i18n.changeLanguage(storedLang);
    }
  }, [i18n, storedLang]);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const checkedLanguage: string = i18n?.language;

  const handleClose = () => {
    setAnchorEl(null);
  };

  const checkLocale = (checkedLang: string) => {
    const checked = locales.filter(({ lang }) => lang === checkedLang);
    return checked[0];
  };

  const handleLanguageChange = (lang: string) => {
    localStorageHelpers.saveToLocalStorage("lang", lang);
    i18nUtil.changeLanguage(lang);
    handleClose();
  };

  return (
    <Container>
      <IconButton
        aria-controls="language-menu"
        aria-haspopup="true"
        onClick={handleClick}
        color="inherit"
      >
        <LocaleInfo>
          <FlagImg src={checkLocale(checkedLanguage).assets} alt="ru" />
        </LocaleInfo>
      </IconButton>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        disableScrollLock
      >
        <MenuItem
          style={{ fontSize: 14 }}
          onClick={() => handleLanguageChange("ru")}
        >
          Русский
        </MenuItem>
        <MenuItem
          style={{ fontSize: 14 }}
          onClick={() => handleLanguageChange("en")}
        >
          English
        </MenuItem>
      </Menu>
    </Container>
  );
};

export default LanguageSelector;

const Container = styled.div`
  display: flex;
  gap: 5px;
  margin-right: 5px;
  label {
    font-size: 14px;
  }
`;

const LocaleInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const FlagImg = styled.img`
  width: 24px;
  height: 24px;
`;
